import { makeObservable, observable } from 'mobx';
import { z } from 'zod';
import type { RequireAllProps } from '../../../../../store/utils/Dto';
import type { AccountSaveMethod } from '../../types';
import Service, { type ServiceDto } from '../Service';

export default class S3Storage extends Service<S3StorageDto> {
  static Schema = z.object({
    apiKey: z.string().min(1),
    apiRegion: z.string(),
    apiSecret: z.string().min(1),
  });

  apiKey = '';
  apiRegion = '';
  apiSecret = '';

  constructor(dto: S3StorageDto = {} as any, onSave?: AccountSaveMethod) {
    super(dto, onSave);

    makeObservable(this, {
      apiKey: observable,
      apiRegion: observable,
      apiSecret: observable,
    });

    Object.assign(this, dto);
  }

  get regionLabel() {
    return this.provider === 'cloudflarestorage.com'
      ? 'Account ID and jurisdictions'
      : 'Region';
  }

  get regionHint() {
    if (this.provider === 'cloudflarestorage.com') {
      return (
        'If you are using a special jurisdiction, ' +
        'place it with a dot after Account ID, like "aa568241cbd0.eu".' +
        'Otherwise keep only the Account ID'
      );
    }

    return '';
  }

  toJSON(): RequireAllProps<S3StorageDto> {
    return {
      ...super.toJSON(),
      apiKey: this.apiKey,
      apiRegion: this.apiRegion || '',
      apiSecret: this.apiSecret,
    };
  }
}

export interface S3StorageDto extends ServiceDto {
  apiKey?: string;
  apiRegion?: string;
  apiSecret?: string;
}
